export default "__VITE_ASSET__48528f78__"